'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _catalogAd = require('./remote/catalogAd');

var CatalogAd = {
    fetchCatalogAd: _catalogAd.CatalogAdRemote.fetchCatalogAd
};

exports.default = CatalogAd;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/catalogAd.js
// module id = 0jBl
// module chunks = 60